import { render } from "./CreateProposal.vue?vue&type=template&id=8af719ce&scoped=true"
import script from "./CreateProposal.vue?vue&type=script&lang=js"
export * from "./CreateProposal.vue?vue&type=script&lang=js"

import "./CreateProposal.vue?vue&type=style&index=0&id=8af719ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af719ce"]])

export default __exports__